export const INITIALIZE_HOW_IT_WORKS = 'initialize-how-it-works';
const initializeHowItWorks = () => ({ type: INITIALIZE_HOW_IT_WORKS });
export default initializeHowItWorks;
